import { useLoaderData } from 'react-router';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { SubPage } from '../components/SiteChrome';
import { LegalDocument } from '../components/LegalDocument';
import { loadSite } from '../lib/publicApi';
import { loadAccountDeletionText } from '../lib/legalContent';
import { pageMeta } from '../lib/seo';

/**
 * `/konto-loeschen` — how to delete the account and what is deleted or kept
 * (D-091, D-093, BR-INV-06). Google Play's account and data deletion URLs
 * point here, so the steps come first; the text is Markdown like the legal
 * texts (`content/legal/konto-loeschen.md`, 08-web-site § 13).
 */
export function meta() {
  return pageMeta({
    title: `${i18next.t('site.accountDeletion.title')} · woo coworking`,
    description: i18next.t('site.accountDeletion.metaDescription'),
    path: '/konto-loeschen',
  });
}

export async function loader() {
  const site = await loadSite();
  return { site, blocks: loadAccountDeletionText(site) };
}

export default function AccountDeletion() {
  const { site, blocks } = useLoaderData<typeof loader>();
  const { t } = useTranslation();
  return (
    <SubPage site={site}>
      <main className="max-w-content mx-auto px-5 py-20">
        <article className="font-body text-text max-w-[760px] text-base leading-normal">
          <h1 className="font-heading text-webH1 text-ink mb-6">{t('site.accountDeletion.title')}</h1>
          <LegalDocument blocks={blocks} />
          <p className="mt-10 print:hidden">
            <a href="/rechtliches" className="text-teal underline">
              {t('site.legal.allTexts')}
            </a>
          </p>
        </article>
      </main>
    </SubPage>
  );
}
